import { motion } from 'motion/react'
import * as React from 'react'

type MenuBgCloseButtonProps = {
  closeMenu: () => void
  label?: string
  className?: string
}

export default function MenuBgCloseButton({
  label = 'Close menu',
  closeMenu,
  className,
}: MenuBgCloseButtonProps) {
  return (
    <motion.button
      aria-label={label}
      className={`absolute--fill bg-white/80 ${className}`}
      onClick={closeMenu}
      initial={{ opacity: 0 }}
      animate={{
        opacity: 1,
      }}
      exit={{ opacity: 0, transition: { duration: 0.05 } }}
      style={{
        cursor: 'w-resize',
      }}
    />
  )
}
